var map = {
	"./App_Store.svg": 32,
	"./ArrowRight.svg": 12,
	"./Arrowback.svg": 13,
	"./Design.svg": 33,
	"./Functies.svg": 34,
	"./Gegevens.svg": 35,
	"./Integraties.svg": 36,
	"./Notifications.svg": 37,
	"./Offline-online.svg": 38,
	"./Toestellen.svg": 39,
	"./Type.svg": 40,
	"./desktop-icon.svg": 41,
	"./frame-cards.png": 42,
	"./frame-cards.svg": 14,
	"./icons/android-icon-144x144.png": 43,
	"./icons/android-icon-192x192.png": 44,
	"./icons/android-icon-36x36.png": 45,
	"./icons/android-icon-48x48.png": 46,
	"./icons/android-icon-72x72.png": 47,
	"./icons/android-icon-96x96.png": 48,
	"./icons/apple-icon-114x114.png": 49,
	"./icons/apple-icon-120x120.png": 50,
	"./icons/apple-icon-144x144.png": 51,
	"./icons/apple-icon-152x152.png": 52,
	"./icons/apple-icon-180x180.png": 53,
	"./icons/apple-icon-57x57.png": 54,
	"./icons/apple-icon-60x60.png": 55,
	"./icons/apple-icon-72x72.png": 56,
	"./icons/apple-icon-76x76.png": 57,
	"./icons/apple-icon-precomposed.png": 58,
	"./icons/apple-icon.png": 59,
	"./icons/favicon-16x16.png": 60,
	"./icons/favicon-32x32.png": 61,
	"./icons/favicon-96x96.png": 62,
	"./icons/favicon.ico": 63,
	"./icons/ms-icon-144x144.png": 64,
	"./icons/ms-icon-150x150.png": 65,
	"./icons/ms-icon-310x310.png": 66,
	"./icons/ms-icon-70x70.png": 67,
	"./logo-google-play.svg": 68,
	"./logo.svg": 10,
	"./smartphone-icon.svg": 69,
	"./tablet-icon.svg": 70,
	"./web-app.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;